export type Theme = 'light' | 'dark'

const storageKey = 'theme'
const darkClass = 'app-dark'

// Явный выбор пользователя важнее системной настройки; без выбора — prefers-color-scheme.
function resolveTheme(): Theme {
  const stored = localStorage.getItem(storageKey)
  if (stored === 'dark' || stored === 'light') return stored
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

class ThemeService {
  public applyStoredTheme(): void {
    document.documentElement.classList.toggle(darkClass, resolveTheme() === 'dark')
  }

  public isDark(): boolean {
    return document.documentElement.classList.contains(darkClass)
  }

  public toggle(): Theme {
    const next: Theme = this.isDark() ? 'light' : 'dark'
    document.documentElement.classList.toggle(darkClass, next === 'dark')
    localStorage.setItem(storageKey, next)
    return next
  }
}

export default new ThemeService()
